var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-cy":"logged-user"}},[_c('span',[_vm._v(_vm._s(_vm.loggedUser.username)+" ")]),_c('a',{attrs:{"href":"/"},on:{"click":_vm.logoutUser}},[_vm._v("Wyloguj")])])}
var staticRenderFns = []

export { render, staticRenderFns }